/* ==========================================================================
   Bundle Builder — product fetching, filters, bundle state, cart
   ========================================================================== */

(function () {
  'use strict';

  var CONFIG = window.BB_CONFIG || {};
  var root = document.getElementById('bundle-builder');
  if (!root) return;

  /* ---- state ------------------------------------------------------------ */

  var state = {
    filters: {
      recipient: 'for-her',
      occasion: 'birthday',
      experience: 'wellness'
    },
    budget: CONFIG.defaultBudget || 3000,
    sort: 'recommended',
    allProducts: [],   // full set fetched from the collection
    visibleCount: 8,   // how many cards to show ("Load More")
    bundle: []         // items added to the bundle
  };

  /* ---- dom refs ----------------------------------------------------------*/

  var els = {
    chipRows: root.querySelectorAll('.bb-chip-row'),
    budgetDisplay: document.getElementById('bb-budget-display'),
    budgetChangeBtn: document.getElementById('bb-budget-change-btn'),
    budgetSliderWrap: document.getElementById('bb-budget-slider-wrap'),
    budgetSlider: document.getElementById('bb-budget-slider'),
    budgetConfirmBtn: document.getElementById('bb-budget-confirm-btn'),
    budgetLabel: document.getElementById('bb-budget-label'),

    itemCount: document.getElementById('bb-item-count'),
    totalDisplay: document.getElementById('bb-total-display'),
    remainingDisplay: document.getElementById('bb-remaining-display'),
    progressFill: document.getElementById('bb-progress-fill'),
    tip: document.getElementById('bb-tip'),

    productsGrid: document.getElementById('bb-products-grid'),
    loadMoreBtn: document.getElementById('bb-load-more'),
    sortSelect: document.getElementById('bb-sort'),

    bundleGrid: document.getElementById('bb-bundle-grid'),
    bundleEmpty: document.getElementById('bb-bundle-empty'),
    footerCount: document.getElementById('bb-footer-count'),
    footerTotal: document.getElementById('bb-footer-total'),
    footerRemaining: document.getElementById('bb-footer-remaining'),

    giftNote: document.getElementById('bb-gift-note'),
    noteCount: document.getElementById('bb-note-count'),

    addToCartBtn: document.getElementById('bb-add-to-cart'),
    saveBundleBtn: document.getElementById('bb-save-bundle'),

    toast: document.getElementById('bb-toast'),

    modalOverlay: document.getElementById('bb-modal-overlay'),
    modalClose: document.getElementById('bb-modal-close'),
    modalLink: document.getElementById('bb-modal-link'),
    modalCopy: document.getElementById('bb-modal-copy')
  };

  /* ---- helpers ----------------------------------------------------------- */

  function formatMoney(cents) {
    // cents -> "₹1,234"
    var amount = Math.round(cents / 100);
    var symbol = CONFIG.currencySymbol || '₹';
    return symbol + amount.toLocaleString('en-IN');
  }

  function showToast(message) {
    if (!els.toast) return;
    els.toast.textContent = message;
    els.toast.classList.add('bb-toast--visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () {
      els.toast.classList.remove('bb-toast--visible');
    }, 2400);
  }

  function activeTagsForFilters() {
    // Maps current chip selections to the Shopify tags set in section settings.
    var t = CONFIG.tags || {};
    var tags = [];
    var map = {
      'for-her': t.forHer, 'for-him': t.forHim, 'for-them': t.forThem,
      'birthday': t.birthday, 'anniversary': t.anniversary, 'festival': t.festival, 'self-care': t.selfCare,
      'wellness': t.wellness, 'artisan': t.artisan, 'gourmet': t.gourmet, 'home': t.home
    };
    ['recipient', 'occasion', 'experience'].forEach(function (group) {
      var val = state.filters[group];
      if (map[val]) tags.push(map[val]);
    });
    return tags;
  }

  /* ---- fetching products -------------------------------------------------- */

  function fetchProducts() {
    setGridLoading();

    var handle = CONFIG.collectionHandle || 'all';
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        state.allProducts = (data.products || []).map(normalizeProduct);
        state.visibleCount = 8;
        renderProducts();
      })
      .catch(function (err) {
        console.error('[bundle-builder] product fetch failed', err);
        renderProductError();
      });
  }

  function normalizeProduct(p) {
    var variant = (p.variants && p.variants[0]) || {};
    return {
      id: p.id,
      variantId: variant.id,
      title: p.title,
      handle: p.handle,
      tags: (p.tags || []).map(function (t) { return String(t).toLowerCase(); }),
      price: Math.round(parseFloat(variant.price || '0') * 100), // cents
      image: (p.images && p.images[0] && p.images[0].src) || (p.featured_image || '')
    };
  }

  function getFilteredProducts() {
    var tags = activeTagsForFilters();
    var list = state.allProducts;

    if (tags.length) {
      list = list.filter(function (p) {
        return tags.some(function (tag) { return p.tags.indexOf(tag.toLowerCase()) !== -1; });
      });
    }

    // Only show items that fit inside the remaining budget so recommendations stay useful.
    var remaining = remainingBudget();
    list = list.slice().sort(function (a, b) {
      if (state.sort === 'price-asc') return a.price - b.price;
      if (state.sort === 'price-desc') return b.price - a.price;
      // "recommended": items within budget first, cheapest first within that
      var aFits = a.price <= remaining ? 0 : 1;
      var bFits = b.price <= remaining ? 0 : 1;
      if (aFits !== bFits) return aFits - bFits;
      return a.price - b.price;
    });

    return list;
  }

  /* ---- rendering: products grid ------------------------------------------- */

  function setGridLoading() {
    els.productsGrid.innerHTML =
      '<div class="bb-product-skeleton"></div>'.repeat(4);
    els.loadMoreBtn.style.display = 'none';
  }

  function renderProductError() {
    els.productsGrid.innerHTML =
      '<div class="bb-error-state">Couldn\'t load products right now. Please refresh the page.</div>';
    els.loadMoreBtn.style.display = 'none';
  }

  function renderProducts() {
    var filtered = getFilteredProducts();

    if (!filtered.length) {
      els.productsGrid.innerHTML =
        '<div class="bb-empty-state">No products match these filters yet. Try a different combination.</div>';
      els.loadMoreBtn.style.display = 'none';
      return;
    }

    var visible = filtered.slice(0, state.visibleCount);
    els.productsGrid.innerHTML = visible.map(renderProductCard).join('');

    els.loadMoreBtn.style.display = filtered.length > visible.length ? 'block' : 'none';

    // wire up add buttons
    els.productsGrid.querySelectorAll('.bb-product-card__add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-id');
        var product = state.allProducts.filter(function (p) { return String(p.id) === id; })[0];
        if (product) addToBundle(product);
      });
    });
  }

  function renderProductCard(p) {
    var inBundle = state.bundle.some(function (b) { return b.id === p.id; });
    var overBudget = !inBundle && p.price > remainingBudget();
    var img = p.image
      ? '<img class="bb-product-card__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
      : '';

    return (
      '<div class="bb-product-card">' +
        '<div class="bb-product-card__image-wrap">' + img + '</div>' +
        '<div class="bb-product-card__body">' +
          '<p class="bb-product-card__title">' + escapeHtml(p.title) + '</p>' +
          '<p class="bb-product-card__price">' + formatMoney(p.price) + '</p>' +
          '<button class="bb-product-card__add' + (inBundle ? ' bb-product-card__add--added' : '') + '" ' +
            'data-id="' + p.id + '" ' + (overBudget ? 'disabled' : '') + '>' +
            (inBundle ? 'Added ✓' : (overBudget ? 'Over budget' : '+ Add to Bundle')) +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  /* ---- bundle state -------------------------------------------------------- */

  function addToBundle(product) {
    if (state.bundle.some(function (b) { return b.id === product.id; })) return;
    state.bundle.push(product);
    renderBundle();
    renderProducts(); // refresh "Add" buttons / over-budget states
    showToast(product.title + ' added to your bundle');
  }

  function removeFromBundle(id) {
    state.bundle = state.bundle.filter(function (b) { return b.id !== id; });
    renderBundle();
    renderProducts();
  }

  function bundleTotal() {
    return state.bundle.reduce(function (sum, p) { return sum + p.price; }, 0);
  }

  function remainingBudget() {
    return Math.max(state.budget * 100 - bundleTotal(), -999999999);
  }

  function renderBundle() {
    var total = bundleTotal();
    var remaining = state.budget * 100 - total;
    var count = state.bundle.length;

    // sidebar summary
    els.itemCount.textContent = count;
    els.totalDisplay.textContent = formatMoney(total);
    els.remainingDisplay.textContent = formatMoney(remaining);
    els.remainingDisplay.classList.toggle('bb-summary-remaining--over', remaining < 0);

    var pct = state.budget > 0 ? Math.min((total / (state.budget * 100)) * 100, 100) : 0;
    els.progressFill.style.width = pct + '%';
    els.progressFill.classList.toggle('bb-progress-fill--over', remaining < 0);

    if (els.tip) {
      els.tip.querySelector('.bb-tip__text').textContent = remaining < 0
        ? 'You are over budget — remove an item or increase your budget.'
        : count === 0
          ? 'Add items from recommendations within your budget.'
          : 'Looking good! Add more or head to checkout when ready.';
    }

    // footer
    els.footerCount.textContent = count;
    els.footerTotal.textContent = formatMoney(total);
    els.footerRemaining.textContent = formatMoney(remaining);

    // bundle grid
    if (count === 0) {
      els.bundleGrid.innerHTML =
        '<div class="bb-bundle-empty" id="bb-bundle-empty">' +
          '<span class="bb-bundle-empty__icon">🎁</span>' +
          '<p>Your bundle is empty. Add items from the recommendations above.</p>' +
        '</div>';
    } else {
      els.bundleGrid.innerHTML = state.bundle.map(function (p, i) {
        var img = p.image ? '<img class="bb-bundle-item__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '">' : '';
        return (
          '<div class="bb-bundle-item" draggable="true" data-index="' + i + '" data-id="' + p.id + '">' +
            '<button class="bb-bundle-item__remove" data-id="' + p.id + '" aria-label="Remove">✕</button>' +
            img +
            '<p class="bb-bundle-item__title">' + escapeHtml(p.title) + '</p>' +
            '<p class="bb-bundle-item__price">' + formatMoney(p.price) + '</p>' +
          '</div>'
        );
      }).join('');

      els.bundleGrid.querySelectorAll('.bb-bundle-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeFromBundle(Number(btn.getAttribute('data-id')));
        });
      });

      wireDragReorder();
    }

    els.addToCartBtn.disabled = count === 0;
  }

  /* ---- drag to reorder ------------------------------------------------------ */

  function wireDragReorder() {
    var items = els.bundleGrid.querySelectorAll('.bb-bundle-item');
    var dragSrcIndex = null;

    items.forEach(function (item) {
      item.addEventListener('dragstart', function () {
        dragSrcIndex = Number(item.getAttribute('data-index'));
        item.classList.add('bb-bundle-item--dragging');
      });
      item.addEventListener('dragend', function () {
        item.classList.remove('bb-bundle-item--dragging');
      });
      item.addEventListener('dragover', function (e) {
        e.preventDefault();
      });
      item.addEventListener('drop', function (e) {
        e.preventDefault();
        var targetIndex = Number(item.getAttribute('data-index'));
        if (dragSrcIndex === null || targetIndex === dragSrcIndex) return;
        var moved = state.bundle.splice(dragSrcIndex, 1)[0];
        state.bundle.splice(targetIndex, 0, moved);
        renderBundle();
      });
    });
  }

  /* ---- filter chips ----------------------------------------------------------*/

  els.chipRows.forEach(function (row) {
    var group = row.getAttribute('data-filter');
    row.addEventListener('click', function (e) {
      var chip = e.target.closest('.bb-chip');
      if (!chip || !row.contains(chip)) return;

      row.querySelectorAll('.bb-chip').forEach(function (c) { c.classList.remove('bb-chip--active'); });
      chip.classList.add('bb-chip--active');

      state.filters[group] = chip.getAttribute('data-value');
      state.visibleCount = 8;
      renderProducts();
    });
  });

  /* ---- budget controls -------------------------------------------------------*/

  if (els.budgetChangeBtn) {
    els.budgetChangeBtn.addEventListener('click', function () {
      var open = els.budgetSliderWrap.style.display !== 'none';
      els.budgetSliderWrap.style.display = open ? 'none' : 'block';
    });
  }

  if (els.budgetSlider) {
    els.budgetSlider.addEventListener('input', function () {
      els.budgetDisplay.textContent = Number(els.budgetSlider.value).toLocaleString('en-IN');
    });
  }

  if (els.budgetConfirmBtn) {
    els.budgetConfirmBtn.addEventListener('click', function () {
      state.budget = Number(els.budgetSlider.value);
      els.budgetDisplay.textContent = state.budget.toLocaleString('en-IN');
      els.budgetLabel.textContent = state.budget.toLocaleString('en-IN');
      els.budgetSliderWrap.style.display = 'none';
      renderBundle();
      renderProducts();
    });
  }

  /* ---- sort --------------------------------------------------------------------*/

  if (els.sortSelect) {
    els.sortSelect.addEventListener('change', function () {
      state.sort = els.sortSelect.value;
      renderProducts();
    });
  }

  /* ---- load more ----------------------------------------------------------------*/

  if (els.loadMoreBtn) {
    els.loadMoreBtn.addEventListener('click', function () {
      state.visibleCount += 8;
      renderProducts();
    });
  }

  /* ---- gift note character count -------------------------------------------------*/

  if (els.giftNote) {
    els.giftNote.addEventListener('input', function () {
      els.noteCount.textContent = els.giftNote.value.length;
    });
  }

  /* ---- add to cart ----------------------------------------------------------------*/

  if (els.addToCartBtn) {
    els.addToCartBtn.addEventListener('click', function () {
      if (!state.bundle.length) return;

      var items = state.bundle.map(function (p) {
        return { id: p.variantId, quantity: 1 };
      });

      var giftWrapChecked = root.querySelector('input[name="gift-wrap"]:checked');
      if (giftWrapChecked && giftWrapChecked.value === 'yes' && CONFIG.giftWrapProductId) {
        items.push({ id: CONFIG.giftWrapProductId, quantity: 1 });
      }

      var noteValue = els.giftNote ? els.giftNote.value : '';

      els.addToCartBtn.disabled = true;
      els.addToCartBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          if (noteValue) {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ note: noteValue })
            });
          }
        })
        .then(function () {
          showToast('Bundle added to cart 🎁');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('[bundle-builder] add to cart failed', err);
          showToast('Something went wrong adding your bundle. Please try again.');
        })
        .finally(function () {
          els.addToCartBtn.disabled = state.bundle.length === 0;
          els.addToCartBtn.textContent = '🛒 Add Bundle to Cart';
        });
    });
  }

  /* ---- save bundle (shareable link) ------------------------------------------------*/

  if (els.saveBundleBtn) {
    els.saveBundleBtn.addEventListener('click', function () {
      var ids = state.bundle.map(function (p) { return p.id; }).join(',');
      var url = new URL(CONFIG.pageUrl || window.location.pathname, CONFIG.shopUrl || window.location.origin);
      url.searchParams.set('bundle', ids);
      url.searchParams.set('budget', state.budget);

      els.modalLink.value = url.toString();
      els.modalOverlay.style.display = 'flex';
    });
  }

  if (els.modalClose) {
    els.modalClose.addEventListener('click', function () {
      els.modalOverlay.style.display = 'none';
    });
  }

  if (els.modalOverlay) {
    els.modalOverlay.addEventListener('click', function (e) {
      if (e.target === els.modalOverlay) els.modalOverlay.style.display = 'none';
    });
  }

  if (els.modalCopy) {
    els.modalCopy.addEventListener('click', function () {
      els.modalLink.select();
      navigator.clipboard.writeText(els.modalLink.value).then(function () {
        showToast('Link copied to clipboard');
      }).catch(function () {
        document.execCommand('copy');
        showToast('Link copied to clipboard');
      });
    });
  }

  /* ---- restore a saved bundle from URL, if present ---------------------------------*/

  function restoreFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var budgetParam = params.get('budget');
    if (budgetParam && !isNaN(Number(budgetParam))) {
      state.budget = Number(budgetParam);
      if (els.budgetDisplay) els.budgetDisplay.textContent = state.budget.toLocaleString('en-IN');
      if (els.budgetLabel) els.budgetLabel.textContent = state.budget.toLocaleString('en-IN');
      if (els.budgetSlider) els.budgetSlider.value = state.budget;
    }

    var bundleParam = params.get('bundle');
    if (bundleParam) {
      var ids = bundleParam.split(',').map(Number);
      // deferred until products are fetched
      restoreFromUrl._pendingIds = ids;
    }
  }

  function applyPendingBundleRestore() {
    var ids = restoreFromUrl._pendingIds;
    if (!ids || !ids.length) return;
    state.bundle = state.allProducts.filter(function (p) { return ids.indexOf(p.id) !== -1; });
    renderBundle();
  }

  /* ---- init ------------------------------------------------------------------------*/

  restoreFromUrl();
  fetchProducts();
  renderBundle();

  var originalRenderProducts = renderProducts;
  renderProducts = function () {
    originalRenderProducts();
    if (restoreFromUrl._pendingIds) {
      applyPendingBundleRestore();
      restoreFromUrl._pendingIds = null;
    }
  };

})();